import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .Title': {
        marginBottom: toRem(20),
        fontSize: toRem(22),
        fontFamily: 'Poppins',

        [theme.breakpoints.up('md')]: {
            display: 'block'
        },

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(24)
        },

        [theme.breakpoints.up('xl')]: {
            marginBottom: toRem(60)
        }
    },
    '& p': {
        fontSize: toRem(16),
        marginBottom: toRem(25),
        fontWeight: 300,
        lineHeight: '26px',

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(20),
            lineHeight: '36px'
        }
    }
})

export default style
